if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      this.currentActiveSlide = null;

      this.initAdaptiveHeight();

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', (event) => {
        this.onSlideChanged(event);
      });

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveMedia(mediaToSwitch.dataset.target, false);
        });
      });

      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (!event.detail || !event.detail.currentElement) return;
      const slide = event.detail.currentElement;
      this.currentActiveSlide = slide;

      if (this.elements.thumbnails && slide.dataset.mediaId) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
        if (thumbnail) this.setActiveThumbnail(thumbnail);
      }

      this.updateGalleryHeight(slide);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      this.currentActiveSlide = activeMedia;

      // Immediately trigger adaptive height transition
      this.updateGalleryHeight(activeMedia);

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'smooth'
          });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      const btn = thumbnail.querySelector('button');
      if (btn) btn.setAttribute('aria-current', 'true');

      if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
        }
      } else {
        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = (window.accessibilityStrings && window.accessibilityStrings.imageAvailable)
          ? window.accessibilityStrings.imageAvailable.replace('[index]', position)
          : `Slajd ${position}`;
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if (window.pauseAllMedia) window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    }

    getSlideHeight(slide) {
      if (!slide) return 0;

      const viewer = this.elements.viewer;
      const sliderList = viewer.querySelector('.product__media-list') || viewer;
      const width = (slide.clientWidth > 50) ? slide.clientWidth : (sliderList.clientWidth > 50 ? sliderList.clientWidth : (viewer.clientWidth || window.innerWidth));

      let ratio = null;

      // 1. Inspect liquid rendered --preview-ratio or --ratio on container
      const container = slide.querySelector('.product-media-container');
      if (container) {
        const inlineStyle = container.getAttribute('style') || '';
        const match = inlineStyle.match(/--preview-ratio:\s*([0-9.]+)/) || inlineStyle.match(/--ratio:\s*([0-9.]+)/);
        if (match && match[1]) {
          const val = parseFloat(match[1]);
          if (!isNaN(val) && val > 0.1 && val < 10) {
            ratio = 1 / val;
          }
        }
        if (!ratio) {
          const compVal = parseFloat(getComputedStyle(container).getPropertyValue('--preview-ratio'));
          if (!isNaN(compVal) && compVal > 0.1 && compVal < 10) {
            ratio = 1 / compVal;
          }
        }
      }

      // 2. Inspect img natural dimensions
      const img = slide.querySelector('img');
      if (!ratio && img && img.naturalWidth && img.naturalHeight && img.naturalWidth > 0) {
        ratio = img.naturalHeight / img.naturalWidth;
      }

      // 3. Fallback
      if (!ratio || isNaN(ratio)) {
        ratio = 1.0;
      }

      let targetHeight = Math.round(width * ratio);

      // Desktop constraint: don't exceed viewport height
      if (window.innerWidth >= 750) {
        const maxDesktopH = Math.round(window.innerHeight * 0.82);
        if (targetHeight > maxDesktopH) {
          targetHeight = maxDesktopH;
        }
      }

      return targetHeight;
    }

    updateGalleryHeight(activeItem) {
      if (!this.elements.viewer) return;

      const slide = activeItem ||
                    this.currentActiveSlide ||
                    this.elements.viewer.querySelector('.product__media-item.is-active') ||
                    this.elements.viewer.querySelector('.product__media-item');

      if (!slide) return;

      const targetHeight = this.getSlideHeight(slide);
      if (targetHeight && targetHeight > 50) {
        this.elements.viewer.setAttribute('data-height-ready', 'true');
        this.elements.viewer.style.setProperty('height', `${targetHeight}px`, 'important');

        const sliderList = this.elements.viewer.querySelector('.product__media-list');
        if (sliderList) {
          sliderList.style.setProperty('height', `${targetHeight}px`, 'important');
        }
      }
    }

    initAdaptiveHeight() {
      if (!this.elements.viewer) return;

      const sliderList = this.elements.viewer.querySelector('.product__media-list');
      const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));

      const setSlideActive = (slide) => {
        if (!slide || slide === this.currentActiveSlide) return;
        this.currentActiveSlide = slide;

        slides.forEach(s => s.classList.remove('is-active'));
        slide.classList.add('is-active');

        this.updateGalleryHeight(slide);

        if (this.elements.thumbnails && slide.dataset.mediaId) {
          const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
          if (activeThumb) {
            this.setActiveThumbnail(activeThumb);
          }
        }
      };

      // 1. Initial measurement
      const initialSlide = this.elements.viewer.querySelector('.product__media-item.is-active') || slides[0];
      if (initialSlide) {
        this.currentActiveSlide = initialSlide;
        this.updateGalleryHeight(initialSlide);
      }

      // Re-measure after resources load
      [30, 100, 250, 500, 1000].forEach(delay => {
        setTimeout(() => {
          const active = this.currentActiveSlide || this.elements.viewer.querySelector('.product__media-item.is-active') || slides[0];
          if (active) this.updateGalleryHeight(active);
        }, delay);
      });

      // 2. High-performance scroll tracking on mobile slider
      if (sliderList) {
        let ticking = false;
        const onScroll = () => {
          const scrollLeft = sliderList.scrollLeft;
          const listWidth = sliderList.clientWidth;
          const centerPoint = scrollLeft + listWidth / 2;

          let closestSlide = null;
          let minDistance = Infinity;

          slides.forEach(slide => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const dist = Math.abs(slideCenter - centerPoint);
            if (dist < minDistance) {
              minDistance = dist;
              closestSlide = slide;
            }
          });

          if (closestSlide && closestSlide !== this.currentActiveSlide) {
            setSlideActive(closestSlide);
          }
        };

        sliderList.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(() => {
              onScroll();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
      }

      // 3. IntersectionObserver for slides (extra precision on mobile swipe)
      if (typeof IntersectionObserver !== 'undefined' && sliderList) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              if (entry.target !== this.currentActiveSlide) {
                setSlideActive(entry.target);
              }
            }
          });
        }, {
          root: sliderList,
          threshold: [0.5, 0.75]
        });

        slides.forEach(slide => observer.observe(slide));
      }

      // 4. Track image load events
      this.elements.viewer.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            const active = this.currentActiveSlide || this.elements.viewer.querySelector('.product__media-item.is-active') || slides[0];
            if (active) this.updateGalleryHeight(active);
          }, { once: true });
        }
      });

      // 5. Window resize
      window.addEventListener('resize', () => {
        const active = this.currentActiveSlide || this.elements.viewer.querySelector('.product__media-item.is-active') || slides[0];
        if (active) this.updateGalleryHeight(active);
      }, { passive: true });

      // 6. ResizeObserver on viewer
      if (typeof ResizeObserver !== 'undefined') {
        let lastWidth = this.elements.viewer.clientWidth;
        this.galleryResizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const curWidth = Math.round(entry.contentRect.width);
            if (curWidth && Math.abs(curWidth - lastWidth) > 5) {
              lastWidth = curWidth;
              const active = this.currentActiveSlide || this.elements.viewer.querySelector('.product__media-item.is-active') || slides[0];
              if (active) this.updateGalleryHeight(active);
            }
          }
        });
        this.galleryResizeObserver.observe(this.elements.viewer);
      }
    }
  });
}
